module.exports = __webpack_public_path__ + "img/hd.6b3c9103.jpg";